import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Collapsible, Divider, LILAC_400, Typography, WHITE, getTestId, isFirstItem, isLastItem, isValidObject, useBreakpoint, InView } from '@airtel/air-design-system';
import { Fragment, useEffect, useMemo, useRef, useState } from 'react';
import { View } from 'react-native';
import { ButtonWidget } from '../button-widget';
import { CalloutWidget } from '../callout-widget';
import { ReviewWidget } from '../review-widget';
import { UploadFileWidget } from '../upload-file-widget';
import { defaultProps, fieldVariantData } from './FormWidgetConstants';
import { getFormWidgetStyles, isOdd } from './FormWidgetStyles';
import { globalDebounce, validateInputValues } from './FormWidgetUtils';
import { SingleFormField } from './components/single-form-field';
import { merge } from 'lodash';
export var FormWidgetComponent = props => {
  var _props$heading = props.heading,
    heading = _props$heading === void 0 ? '' : _props$heading,
    _props$calloutProps = props.calloutProps,
    calloutProps = _props$calloutProps === void 0 ? {} : _props$calloutProps,
    _props$calloutPositio = props.calloutPosition,
    calloutPosition = _props$calloutPositio === void 0 ? 'top' : _props$calloutPositio,
    _props$fields = props.fields,
    fields = _props$fields === void 0 ? [] : _props$fields,
    _props$buttonProps = props.buttonProps,
    buttonProps = _props$buttonProps === void 0 ? {} : _props$buttonProps,
    _onUserAction = props.onUserAction,
    _props$errorValues = props.errorValues,
    errorValues = _props$errorValues === void 0 ? {} : _props$errorValues,
    _props$dynamicFieldsP = props.dynamicFieldsProps,
    dynamicFieldsProps = _props$dynamicFieldsP === void 0 ? {} : _props$dynamicFieldsP,
    _props$uploadFileProp = props.uploadFileProps,
    uploadFileProps = _props$uploadFileProp === void 0 ? {} : _props$uploadFileProp,
    _props$isLoading = props.isLoading,
    isLoading = _props$isLoading === void 0 ? false : _props$isLoading,
    _props$reviewsTitle = props.reviewsTitle,
    reviewsTitle = _props$reviewsTitle === void 0 ? '' : _props$reviewsTitle,
    _props$reviews = props.reviews,
    reviews = _props$reviews === void 0 ? [] : _props$reviews,
    currentPlatform = props.currentPlatform,
    dynamicFormButtonDisabled = props.dynamicFormButtonDisabled,
    onValidFormMetaData = props.onValidFormMetaData,
    _props$isValidFormCal = props.isValidFormCallWithDebounce,
    isValidFormCallWithDebounce = _props$isValidFormCal === void 0 ? false : _props$isValidFormCal,
    onInValidFormMetaData = props.onInValidFormMetaData,
    _props$isInValidFormC = props.isInValidFormCallWithDebounce,
    isInValidFormCallWithDebounce = _props$isInValidFormC === void 0 ? false : _props$isInValidFormC,
    _props$debounceDelay = props.debounceDelay,
    debounceDelay = _props$debounceDelay === void 0 ? 800 : _props$debounceDelay,
    id = props.id,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'FormWidgetComponent' : _props$testID,
    onItemVisibleMetaData = props.onItemVisibleMetaData,
    inViewTriggerOnce = props.inViewTriggerOnce,
    style = props.style,
    uploadFileRequired = props.uploadFileRequired;
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isSmallScreen = _useBreakpoint.isSmallScreen;
  var formWidgetStyles = getFormWidgetStyles(isSmallScreen, props);
  var _useState = useState(-1),
    zIndex = _useState[0],
    setZindex = _useState[1];
  var _useState2 = useState({}),
    formData = _useState2[0],
    setFormData = _useState2[1];
  var _useState3 = useState(JSON.parse(JSON.stringify(fields))),
    formFields = _useState3[0],
    setFormFields = _useState3[1];
  var _useState4 = useState(!validateInputValues(fields, formData, currentPlatform)),
    btnDisabled = _useState4[0],
    setBtnDisabled = _useState4[1];
  var hasErrors = useMemo(() => errorValues && Object.keys(errorValues).length > 0, [JSON.stringify(errorValues)]);
  var validCallbackTimer = useRef();
  var invalidCallbackTimer = useRef();
  var formFieldsRefs = useRef({});
  var getRowZindex = (index, field) => {
    if ((field === null || field === void 0 ? void 0 : field.fieldType) === 'DROPDOWN') {
      return formFields.length - index;
    } else if ((field === null || field === void 0 ? void 0 : field.fieldType) === 'DATE') {
      return zIndex;
    } else 0;
  };
  var focusNextOnValidInput = (nextFocusId, currentFieldId, enableValidInputDebounce, onValidInputDelay) => {
    var _a, _b, _c, _d, _e, _f;
    if (enableValidInputDebounce) {
      globalDebounce(() => {
        var _a, _b, _c, _d, _e, _f;
        (_c = (_b = (_a = formFieldsRefs === null || formFieldsRefs === void 0 ? void 0 : formFieldsRefs.current) === null || _a === void 0 ? void 0 : _a[nextFocusId]) === null || _b === void 0 ? void 0 : _b.focus) === null || _c === void 0 ? void 0 : _c.call(_b);
        (_f = (_e = (_d = formFieldsRefs === null || formFieldsRefs === void 0 ? void 0 : formFieldsRefs.current) === null || _d === void 0 ? void 0 : _d[currentFieldId]) === null || _e === void 0 ? void 0 : _e.blur) === null || _f === void 0 ? void 0 : _f.call(_e);
      }, onValidInputDelay)();
    } else {
      (_c = (_b = (_a = formFieldsRefs === null || formFieldsRefs === void 0 ? void 0 : formFieldsRefs.current) === null || _a === void 0 ? void 0 : _a[currentFieldId]) === null || _b === void 0 ? void 0 : _b.blur) === null || _c === void 0 ? void 0 : _c.call(_b);
      (_f = (_e = (_d = formFieldsRefs === null || formFieldsRefs === void 0 ? void 0 : formFieldsRefs.current) === null || _d === void 0 ? void 0 : _d[nextFocusId]) === null || _e === void 0 ? void 0 : _e.focus) === null || _f === void 0 ? void 0 : _f.call(_e);
    }
  };
  useEffect(() => {
    setFormFields(JSON.parse(JSON.stringify(fields)));
  }, [JSON.stringify(fields)]);
  useEffect(() => {
    if (Object.keys(dynamicFieldsProps).length) {
      var formFieldsClone = JSON.parse(JSON.stringify(formFields));
      var dynamicFieldsPropsClone = JSON.parse(JSON.stringify(dynamicFieldsProps));
      setFormFields(formFieldsClone.map(field => {
        var _a, _b;
        if (dynamicFieldsPropsClone === null || dynamicFieldsPropsClone === void 0 ? void 0 : dynamicFieldsPropsClone[field.fieldId]) {
          if (field.fieldType === 'RADIO') {
            (_b = (_a = field === null || field === void 0 ? void 0 : field.fieldData) === null || _a === void 0 ? void 0 : _a.radioButtons) === null || _b === void 0 ? void 0 : _b.map((radioItem, index) => {
              var _a, _b, _c;
              if ((_a = dynamicFieldsPropsClone === null || dynamicFieldsPropsClone === void 0 ? void 0 : dynamicFieldsPropsClone[field.fieldId]) === null || _a === void 0 ? void 0 : _a[radioItem.id]) {
                field.fieldData.radioButtons[index] = Object.assign(Object.assign({}, field.fieldData.radioButtons[index]), (_b = dynamicFieldsPropsClone === null || dynamicFieldsPropsClone === void 0 ? void 0 : dynamicFieldsPropsClone[field.fieldId]) === null || _b === void 0 ? void 0 : _b[radioItem.id]);
              }
              (_c = dynamicFieldsPropsClone === null || dynamicFieldsPropsClone === void 0 ? void 0 : dynamicFieldsPropsClone[field.fieldId]) === null || _c === void 0 ? true : delete _c[radioItem.id];
            });
          }
          return Object.assign(Object.assign({}, field), {
            fieldData: Object.assign(Object.assign({}, field.fieldData), dynamicFieldsPropsClone === null || dynamicFieldsPropsClone === void 0 ? void 0 : dynamicFieldsPropsClone[field.fieldId])
          });
        } else {
          return field;
        }
      }));
    }
  }, [JSON.stringify(dynamicFieldsProps)]);
  useEffect(() => {
    validateFormData(formData);
  }, [JSON.stringify(formFields), JSON.stringify(Object.values(formData)), hasErrors, dynamicFormButtonDisabled, uploadFileProps === null || uploadFileProps === void 0 ? void 0 : uploadFileProps.uploadedFiles]);
  var updateFormField = function updateFormField(fieldId, fieldValue, shouldTrimText, shouldDeleteFormId) {
    if (shouldTrimText === void 0) {
      shouldTrimText = true;
    }
    if (shouldDeleteFormId === void 0) {
      shouldDeleteFormId = false;
    }
    if (shouldDeleteFormId) {
      setFormData(prev => {
        delete prev[fieldId];
        return prev;
      });
    } else {
      setFormData(data => {
        var newData = Object.assign(Object.assign({}, data), {
          [fieldId]: shouldTrimText && typeof fieldValue === 'string' ? fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.trim() : fieldValue
        });
        return newData;
      });
    }
    setFormFields(oldFormFields => oldFormFields.map(field => {
      if (fieldId === field.fieldId) {
        return Object.assign(Object.assign({}, field), {
          fieldData: Object.assign(Object.assign({}, field.fieldData), {
            value: typeof fieldValue === 'object' ? fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue[0] : fieldValue
          })
        });
      } else {
        return field;
      }
    }));
  };
  var validateFormData = formData => {
    var _a;
    var isValid = validateInputValues(formFields, formData, currentPlatform);
    if (isValid && dynamicFormButtonDisabled !== undefined) {
      isValid = !dynamicFormButtonDisabled;
    }
    if (uploadFileRequired && ((_a = uploadFileProps === null || uploadFileProps === void 0 ? void 0 : uploadFileProps.uploadedFiles) === null || _a === void 0 ? void 0 : _a.length) <= 0) {
      isValid = false;
    }
    var isFormValid = isValid && !hasErrors;
    setBtnDisabled(!isFormValid);
    if (validCallbackTimer.current) clearTimeout(validCallbackTimer.current);
    if (isValidObject(onValidFormMetaData) && isFormValid) {
      if (isValidFormCallWithDebounce) {
        validCallbackTimer.current = setTimeout(() => {
          validCallbackTimer.current = null;
          _onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(Object.assign({
            id
          }, onValidFormMetaData), Object.assign({
            props
          }, formData));
        }, debounceDelay);
      } else {
        _onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(Object.assign({
          id
        }, onValidFormMetaData), Object.assign({
          props
        }, formData));
      }
    }
    if (invalidCallbackTimer.current) clearTimeout(invalidCallbackTimer.current);
    if (isValidObject(onInValidFormMetaData) && !isFormValid) {
      if (isInValidFormCallWithDebounce) {
        invalidCallbackTimer.current = setTimeout(() => {
          invalidCallbackTimer.current = null;
          _onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(Object.assign({
            id
          }, onInValidFormMetaData), Object.assign({
            props
          }, formData));
        }, debounceDelay);
      } else {
        _onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(Object.assign({
          id
        }, onInValidFormMetaData), Object.assign({
          props
        }, formData));
      }
    }
  };
  var calloutJsx = _jsx(View, Object.assign({
    style: formWidgetStyles.safeTopSpacing
  }, {
    children: _jsx(CalloutWidget, Object.assign({}, defaultProps.callout, calloutProps, {
      onUserAction: _onUserAction
    }))
  }));
  return _jsxs(View, Object.assign({
    style: [formWidgetStyles.container, style]
  }, getTestId(testID), {
    children: [!!heading && _jsx(Typography, Object.assign({}, defaultProps.heading, {
      text: heading
    })), isValidObject(calloutProps) && calloutPosition == 'top' && calloutJsx, !!(formFields === null || formFields === void 0 ? void 0 : formFields.length) && _jsx(View, Object.assign({
      style: [formWidgetStyles.formContainer, formWidgetStyles.zIndex2]
    }, {
      children: formFields.map((field, index) => {
        var _a;
        var _field = field;
        if (_field.fieldVariantType) {
          _field = merge({}, fieldVariantData[_field.fieldVariantType], _field);
        }
        var fieldId = _field === null || _field === void 0 ? void 0 : _field.fieldId;
        if ((_a = _field === null || _field === void 0 ? void 0 : _field.hideOnPlatform) === null || _a === void 0 ? void 0 : _a.includes(currentPlatform)) {
          return _jsx(Fragment, {}, "field_item_" + fieldId + "_" + index);
        }
        return _jsx(View, Object.assign({
          style: [['INPUT', 'DROPDOWN'].includes(_field === null || _field === void 0 ? void 0 : _field.fieldType) && isOdd(index + 1) && formWidgetStyles.formItemRightSpace, formWidgetStyles.safeTopSpacing, ['INPUT', 'DROPDOWN'].includes(_field === null || _field === void 0 ? void 0 : _field.fieldType) ? formWidgetStyles.formItemInput : formWidgetStyles.formItem, {
            zIndex: getRowZindex(index, _field)
          }, _field === null || _field === void 0 ? void 0 : _field.fieldStyle]
        }, {
          children: _jsx(InView, Object.assign({
            triggerOnce: inViewTriggerOnce,
            onChange: inView => {
              inView && onItemVisibleMetaData && (_onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(Object.assign({
                id
              }, onItemVisibleMetaData), Object.assign({
                index
              }, _field)));
            }
          }, {
            children: _jsx(SingleFormField, Object.assign({}, _field, errorValues === null || errorValues === void 0 ? void 0 : errorValues[fieldId], {
              setZindex: setZindex,
              zIndexValue: formFields.length + 1,
              updateFormField: updateFormField,
              onUserAction: _onUserAction,
              focusNextOnValidInput: focusNextOnValidInput,
              ref: _ref => formFieldsRefs.current[fieldId] = _ref
            }))
          }))
        }), "field_item_" + fieldId + "_" + index);
      })
    })), isValidObject(uploadFileProps) && _jsx(View, Object.assign({
      style: formWidgetStyles.safeTopSpacing
    }, {
      children: _jsx(UploadFileWidget, Object.assign({}, uploadFileProps, {
        onUserAction: (action, extraData) => {
          action && (_onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(action, Object.assign(Object.assign({}, extraData), formData)));
        }
      }))
    })), isValidObject(buttonProps) && _jsx(View, Object.assign({
      style: formWidgetStyles.safeTopSpacing
    }, {
      children: _jsx(ButtonWidget, Object.assign({}, buttonProps, {
        leftCta: Object.assign(Object.assign(Object.assign({}, defaultProps.button), buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.leftCta), {
          disabled: btnDisabled,
          showLoader: isLoading
        }),
        onUserAction: action => {
          action && (_onUserAction === null || _onUserAction === void 0 ? void 0 : _onUserAction(action, Object.assign(Object.assign({}, formData), {
            formData
          })));
        }
      }))
    })), !!(reviews === null || reviews === void 0 ? void 0 : reviews.length) && _jsxs(View, Object.assign({
      style: formWidgetStyles.safeTopSpacing
    }, {
      children: [_jsx(Divider, {
        height: 2,
        color: LILAC_400,
        shadowColor: WHITE
      }), _jsx(Collapsible, Object.assign({
        version: "variable-width",
        childPaddingToken: "SPACING_0",
        titlePaddingToken: "SPACING_0",
        titleComponent: _jsx(Typography, {
          style: formWidgetStyles.reviewsTitle,
          text: reviewsTitle,
          type: "body-single-line-xl-bold"
        }),
        initialOpen: true
      }, {
        children: reviews === null || reviews === void 0 ? void 0 : reviews.map((review, index) => {
          return _createElement(ReviewWidget, Object.assign({}, review, {
            key: "review_item_" + index,
            style: !isFirstItem(index) && formWidgetStyles.reviewContainer,
            isLastReview: isLastItem(reviews, index),
            id: id,
            onUserAction: _onUserAction
          }));
        })
      }))]
    })), isValidObject(calloutProps) && calloutPosition == 'bottom' && calloutJsx]
  }));
};
FormWidgetComponent.genericRendererKey = 'AirFormWidget';